import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ExitImpersonationConfirmModal.css';

interface ExitImpersonationConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  originalUserName?: string;
}

const ExitImpersonationConfirmModal: React.FC<ExitImpersonationConfirmModalProps> = ({ 
  isOpen, 
  onClose,
  onConfirm,
  originalUserName = 'ваш аккаунт'
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const modalContent = (
    <div className="exit-impersonation-confirm-modal-overlay" onClick={onClose}>
      <div className="exit-impersonation-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="exit-impersonation-confirm-modal-close"
          onClick={onClose}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div className="exit-impersonation-confirm-modal-icon">
          <svg width="110" height="110" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="16 17 21 12 16 7" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="21" y1="12" x2="9" y2="12" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 className="exit-impersonation-confirm-modal-message">
          Вернуться в {originalUserName}?
        </h3>
        <p className="exit-impersonation-confirm-modal-description">
          Вы вернетесь к работе от имени своего аккаунта. Все изменения будут сохранены.
        </p>
        <div className="exit-impersonation-confirm-modal-buttons">
          <button 
            className="exit-impersonation-confirm-modal-btn exit-impersonation-confirm-modal-btn-cancel"
            onClick={onClose}
          >
            Отмена
          </button>
          <button 
            className="exit-impersonation-confirm-modal-btn exit-impersonation-confirm-modal-btn-confirm"
            onClick={handleConfirm}
          >
            Вернуться
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ExitImpersonationConfirmModal;
